import { useSuspenseQuery } from '@tanstack/react-query'

import { GetVendedoresUnidadeNegocio } from '@/features/proposta/brasil/http/get-vendedores-unidade-negocio.service'
import { propostaKeys } from '@/features/proposta/brasil/utils'

export const useSuspenseVendedoresUnidadeNegocio = () => {
  return useSuspenseQuery({
    queryKey: propostaKeys.listaVendedores(),
    queryFn: async () => new GetVendedoresUnidadeNegocio().execute().then((res) => res.data),
  })
}
